import { Button, Col, Row } from "react-bootstrap";
import FontFa from "../../../components/fontFa/fontFa";
import { getDDMMYYYFormat } from "../../../helper/dateTimeHelper";
import { Box } from "../../../components/box";
import { documentStatus } from "../../../constants/statusConstants";
import { WordTemplateItems } from "../components/document/document-export-template1";
import { WordTemplateItems2 } from "../components/document/document-export-template2";
import { useEffect, useState } from "react";
import { CreateNotification } from "../../../components/notifier";
import { LoadingModal } from "../modal/loading-modal";
import { useSelector } from "../../../store/store";
import { ApproveProcess } from "./detail-document-process-approve";
import { useSearchParams } from "../../../hook/use-search-params";
import { DetailDocumentViewEditor } from "./detail-document-view-editor";
import { DetailDocumentStepInfo } from "./detail-document-step-info";
import { ContentHistoryVersionModal } from "../modal/content-history-version-modal";
import { Space } from "antd";

export const DocumentProcess = (props: any) => {
  const {
    document,
    toggleEditDocumentProcessModal,
    onSkip,
    onReject,
    onPublish,
    onInterpublish,
    documentHis,
    isReadOnly,
    isInterpublish,
    setSelectedMenu,
    openUrl,
  } = props;
  const { docStatusId } = document;
  const [isView, setIsView] = useState(true);
  const [isShowNextStepButton, setIsShowNextStepButton] = useState(false);
  const user = useSelector((state) => state.user);
  const { searchParams, replaceSearchParams } = useSearchParams();
  const step = searchParams.get("step");
  const mode = searchParams.get("mode");
  const status = searchParams.get("status");
  const isPublishStatus = status === "publish";
  const isStepSelected = (s: string) => step === s;
  const [isOpenModal, setIsOpenModal] = useState(false);

  const getHisNotes = (status: any) => {
    if (docStatusId < status.id && status.id !== 9) return "";

    const docHis = documentHis?.find((e: any) => e.fields.docStatusId === status.id);

    return (
      <div className="py-2 d-flex">
        {docHis && docStatusId !== 1 ? (
          <div className="pr-3 his-note-date">
            Ngày bắt đầu ({getDDMMYYYFormat(docHis?.fields?.approvedDate || docHis?.fields?.createdDateTime)}):
          </div>
        ) : (
          <></>
        )}
        <div className="his-note-content" dangerouslySetInnerHTML={{ __html: docHis?.fields?.docNotes }} />
      </div>
    );
  };

  const getApproved = () => {
    if (!document) return false;
    if (document && document.approvedBy) {
      const approvers = JSON.parse(document.approvedBy) || [];
      return approvers?.findIndex((approver: any) => approver.email === user?.current?.username.toLowerCase()) > -1;
    }
  };

  const getDocDetectors = () => {
    if (!document) return false;
    if (document && document.docDetectors) {
      const approvers = document.docDetectors || [];
      return approvers?.findIndex((approver: any) => approver.email === user?.current?.username.toLowerCase()) > -1;
    }
  };

  const getDocCheckers = () => {
    if (!document) return false;
    if (document && document.docCheckers) {
      const approvers = document.docCheckers || [];
      return approvers?.findIndex((approver: any) => approver.email === user?.current?.username.toLowerCase()) > -1;
    }
  };

  const isOwner = () => {
    if (!document) return false;
    return (
      document.userEmail === user?.current?.username.toLowerCase() ||
      document.userEmail === user?.current?.idTokenClaims.email
    );
  };

  const checkActiveStep = (step: number) => {
    switch (step) {
      case 2:
        return docStatusId !== documentStatus.new.id && docStatusId !== documentStatus.reject.id;
      case 3:
        return docStatusId !== documentStatus.new.id && docStatusId !== documentStatus.compose.id;
      case 4:
        return (
          docStatusId !== documentStatus.new.id &&
          docStatusId !== documentStatus.compose.id &&
          docStatusId !== documentStatus.feedback.id &&
          docStatusId
        );
      case 9:
        return (
          docStatusId !== documentStatus.new.id &&
          docStatusId !== documentStatus.compose.id &&
          docStatusId !== documentStatus.feedback.id &&
          docStatusId !== documentStatus.review.id &&
          docStatusId
        );
      case 5:
        return (
          docStatusId === documentStatus.interimpublish.id ||
          docStatusId === documentStatus.approval.id ||
          docStatusId === documentStatus.readytopublish.id ||
          docStatusId === documentStatus.publish.id
        );
      case 6:
        return (
          docStatusId === documentStatus.approval.id ||
          docStatusId === documentStatus.readytopublish.id ||
          docStatusId === documentStatus.publish.id
        );
      case 7:
        return docStatusId === documentStatus.readytopublish.id || docStatusId === documentStatus.publish.id;
      case 8:
        return docStatusId === documentStatus.publish.id;
      default:
        break;
    }
  };

  const handleStepClick = (s: string) => {
    searchParams.set("step", s);
    replaceSearchParams(searchParams);
  };

  const handlePermissionContent = (mode: "" | "decentralize") => {
    searchParams.set("mode", mode);
    replaceSearchParams(searchParams);
  };

  useEffect(() => {
    if (!isInterpublish) {
      setIsView(false);
      const timer = setTimeout(() => {
        setIsView(true);
      }, 60000);
      return () => clearTimeout(timer);
    }
  }, [isInterpublish]);

  const docReviewers = document.docReviewers ? [...document.docReviewers] : null;
  const docDetectors = document.docDetectors ? [...document.docDetectors] : null;
  const docCheckers = document.docCheckers ? [...document.docCheckers] : null;

  return (
    <div className="px-2">
      <Box
        title={"Quy trình phê duyệt"}
        titleRight={
          <div className="px-3 py-2 d-flex align-items-center">
            {/* <Button onClick={toggleProcessHistoryModal} variant="info">{'Lịch sử ban hành'}</Button> */}
          </div>
        }
      >
        <div>
          <div className="text-center info-header">
            {!document.IsCustomEditor ? (
              <div className="mb-5 header-text">
                <span
                  onClick={async () => await openUrl()}
                  title="Xem thông tin tài liệu"
                  role="link"
                  style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                >
                  {document.Title} <FontFa name="faFile" />
                </span>
              </div>
            ) : document.docPublicVersion > 0 ? (
              <div className="py-2">
                <div className="mb-5 header-text">{document.Title}</div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <Row style={{ width: "100%" }}>
            <Col
              xs={document.IsCustomEditor ? 3 : 12}
              sm={document.IsCustomEditor ? 3 : 12}
              md={document.IsCustomEditor ? 3 : 12}
              className={!document.IsCustomEditor ? "d-flex justify-content-center px-4" : "px-4"}
            >
              <div className="document-detail__info">
                <div className="info-body">
                  <div className="TimelineBox">
                    <div className="item">
                      <div className={`step approved`}>
                        <FontFa name="faCheck" />
                      </div>
                      <div
                        className={isStepSelected(documentStatus.new.value) ? "content active" : "content"}
                        role="button"
                        onClick={() => handleStepClick(documentStatus.new.value)}
                      >
                        <div className="title">Khởi tạo/Soạn thảo</div>
                        <div className="des">{getHisNotes(documentStatus.new)}</div>
                        <div className="des">Người tạo: {document?.userDisplayName}</div>
                        <div className="des">Ngày tạo: {getDDMMYYYFormat(document?.createdDate)}</div>
                        {document.IsCustomEditor && !isReadOnly && docStatusId === documentStatus.new.id && (
                          // isOwner() && (
                          <>
                            <div className="mt-3 d-flex column">
                              <Button
                                size={"sm"}
                                onClick={() => toggleEditDocumentProcessModal()}
                                variant="outline-info"
                              >
                                {"Bắt đầu soạn thảo"}
                              </Button>
                            </div>
                          </>
                        )}
                        {!isReadOnly &&
                          !document.IsCustomEditor &&
                          // isOwner() &&
                          docStatusId === documentStatus.new.id && (
                            <>
                              <div className="mt-3 d-flex column">
                                <Button className="mr-2" size={"sm"} onClick={onPublish} variant="outline-primary">
                                  {"Ban hành"}
                                </Button>
                                <Button className="mr-2" size={"sm"} onClick={onInterpublish} variant="outline-warning">
                                  {"Ban hành tạm thời"}
                                </Button>
                                {/* <Button className="ml-2" size={'sm'} onClick={onSkip} variant="outline-warning">{'Bỏ qua bước kế tiếp'}</Button> */}
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                    {document.IsCustomEditor && (
                      <div className="item">
                        <div className={`step ${checkActiveStep(documentStatus.compose.id) ? "approved" : "waiting"}`}>
                          {checkActiveStep(documentStatus.compose.id) && <FontFa name="faCheck" />}
                        </div>
                        <div
                          className={isStepSelected(documentStatus.compose.value) ? "content active" : "content"}
                          role="button"
                          onClick={() => handleStepClick(documentStatus.compose.value)}
                        >
                          <div className="title d-flex flex-column">
                            <span>{"Đang soạn thảo"}</span>
                            <span
                              style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}
                              className="text-primary"
                              role="button"
                              onClick={() => {
                                searchParams.set("action", "file");
                                searchParams.set("fileId", document.fileId);
                                replaceSearchParams(searchParams);
                                setSelectedMenu("file");
                              }}
                            >
                              {"Chi tiết tài liệu >>>"}
                            </span>
                          </div>
                          <div className="des">{getHisNotes(documentStatus.compose)}</div>
                          {/* {!isReadOnly && docStatusId === documentStatus.compose.id && isOwner() && ( */}
                          {!isReadOnly && docStatusId === documentStatus.compose.id && (
                            <>
                              <div className="mt-3 d-flex column">
                                <Button
                                  className="mr-2"
                                  size={"sm"}
                                  onClick={() => toggleEditDocumentProcessModal()}
                                  variant="outline-info"
                                >
                                  {"Lấy ý kiến"}
                                </Button>
                                <Button className="ml-2" size={"sm"} onClick={onSkip} variant="outline-warning">
                                  {"Bỏ qua bước kế tiếp"}
                                </Button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    {document.IsCustomEditor && (
                      <div className="item">
                        <div className={`step ${checkActiveStep(documentStatus.feedback.id) ? "approved" : "waiting"}`}>
                          {checkActiveStep(documentStatus.feedback.id) && <FontFa name="faCheck" />}
                        </div>
                        <div
                          className={isStepSelected(documentStatus.feedback.value) ? "content active" : "content"}
                          role="button"
                          onClick={() => handleStepClick(documentStatus.feedback.value)}
                        >
                          <div className="title d-flex flex-column">
                            <span>{"Lấy ý kiến"}</span>
                            <span
                              style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}
                              className="text-primary"
                              role="button"
                              onClick={() => {
                                searchParams.set("action", "comment");
                                searchParams.set("fileId", document.fileId);
                                replaceSearchParams(searchParams);
                                setSelectedMenu("comment");
                              }}
                            >
                              {"Danh sách ý kiến >>>"}
                            </span>
                          </div>
                          <div className="des">{getHisNotes(documentStatus.feedback)}</div>
                          {docReviewers &&
                            docReviewers.map((e: any, index: number) => (
                              <div className="des" key={index}>
                                Người ý kiến: {e.displayName} {e.date ? `(${getDDMMYYYFormat(e.date)})` : ""}
                              </div>
                            ))}
                          {/* {!isReadOnly && docStatusId === documentStatus.feedback.id && isOwner() && ( */}
                          {!isReadOnly && docStatusId === documentStatus.feedback.id && (
                            <>
                              <div className="mt-3 d-flex column">
                                <Button
                                  className="mr-2"
                                  size={"sm"}
                                  onClick={() => toggleEditDocumentProcessModal()}
                                  variant="outline-info"
                                >
                                  {"Soát xét"}
                                </Button>
                                <Button className="ml-2" size={"sm"} onClick={onSkip} variant="outline-warning">
                                  {"Bỏ qua bước kế tiếp"}
                                </Button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    {document.IsCustomEditor && (
                      <div className="item">
                        <div className={`step ${checkActiveStep(documentStatus.review.id) ? "approved" : "waiting"}`}>
                          {checkActiveStep(documentStatus.review.id) && <FontFa name="faCheck" />}
                        </div>
                        <div
                          className={isStepSelected(documentStatus.review.value) ? "content active" : "content"}
                          role="button"
                          onClick={() => handleStepClick(documentStatus.review.value)}
                        >
                          <div className="title">{"Soát xét"}</div>
                          <div className="des">{getHisNotes(documentStatus.review)}</div>
                          {docDetectors &&
                            docDetectors.map((e: any, index: number) => (
                              <div className="des" key={index}>
                                Người soát xét: {e.displayName} {e.date ? `(${getDDMMYYYFormat(e.date)})` : ""}
                              </div>
                            ))}
                          {!isReadOnly &&
                            docStatusId === documentStatus.review.id &&
                            (isOwner() || getDocDetectors()) && (
                              <>
                                <ApproveProcess
                                  onReject={() => onReject("Soát xét")}
                                  docApproveData={document?.docDetectors || []}
                                  isOwner={isOwner()}
                                  docId={document?.id}
                                  document={document}
                                  setIsShowNextStepButton={setIsShowNextStepButton}
                                  userEmail={user?.current?.username.toLowerCase()}
                                  updateFields={"docDetectors"}
                                />
                                {/* {isShowNextStepButton && isOwner() && ( */}
                                {isShowNextStepButton && (
                                  <div className="mt-3 d-flex column">
                                    <Button
                                      className="mr-2"
                                      size={"sm"}
                                      onClick={() => {
                                        toggleEditDocumentProcessModal();
                                        setIsShowNextStepButton(false);
                                      }}
                                      variant="outline-info"
                                    >
                                      {"Kiểm tra"}
                                    </Button>
                                    {/* <Button className="mr-2" size={'sm'} onClick={() => onReject('Soát xét')} variant="outline-danger">{'Từ chối'}</Button> */}
                                    <Button size={"sm"} onClick={onSkip} variant="outline-warning">
                                      {"Bỏ qua bước kế tiếp"}
                                    </Button>
                                  </div>
                                )}
                              </>
                            )}
                        </div>
                      </div>
                    )}
                    {document.IsCustomEditor && (
                      <div className="item">
                        <div className={`step ${checkActiveStep(documentStatus.check.id) ? "approved" : "waiting"}`}>
                          {checkActiveStep(documentStatus.check.id) && <FontFa name="faCheck" />}
                        </div>
                        <div
                          className={isStepSelected(documentStatus.check.value) ? "content active" : "content"}
                          role="button"
                          onClick={() => handleStepClick(documentStatus.check.value)}
                        >
                          <div className="title">{"Kiểm tra"}</div>
                          <div className="des">{getHisNotes(documentStatus.check)}</div>
                          {docCheckers &&
                            docCheckers.map((e: any, index: number) => (
                              <div className="des" key={index}>
                                Người kiểm tra: {e.displayName} {e.date ? `(${getDDMMYYYFormat(e.date)})` : ""}
                              </div>
                            ))}
                          {!isReadOnly &&
                            docStatusId === documentStatus.check.id &&
                            (isOwner() || getDocCheckers()) && (
                              <>
                                <ApproveProcess
                                  onReject={() => onReject("kiểm tra")}
                                  docApproveData={document?.docCheckers || []}
                                  isOwner={isOwner()}
                                  docId={document?.id}
                                  document={document}
                                  setIsShowNextStepButton={setIsShowNextStepButton}
                                  userEmail={user?.current?.username.toLowerCase()}
                                  updateFields={"docCheckers"}
                                />
                                {/* {isShowNextStepButton && isOwner() && ( */}
                                {isShowNextStepButton && (
                                  <div className="mt-3 d-flex column">
                                    <Button
                                      className="mr-2"
                                      size={"sm"}
                                      onClick={onInterpublish}
                                      variant="outline-info"
                                    >
                                      {"Ban hành tạm thời"}
                                    </Button>
                                    {/* <Button className="mr-2" size={'sm'} onClick={() => onReject('kiểm tra')} variant="outline-danger">{'Từ chối'}</Button> */}
                                    <Button size={"sm"} onClick={onSkip} variant="outline-warning">
                                      {"Bỏ qua bước kế tiếp"}
                                    </Button>
                                  </div>
                                )}
                              </>
                            )}
                        </div>
                      </div>
                    )}
                    <div className="item">
                      <div
                        className={`step ${checkActiveStep(documentStatus.interimpublish.id) ? "approved" : "waiting"}`}
                      >
                        {checkActiveStep(documentStatus.interimpublish.id) && <FontFa name="faCheck" />}
                      </div>
                      <div
                        className={isStepSelected(documentStatus.interimpublish.value) ? "content active" : "content"}
                        role="button"
                        onClick={() => handleStepClick(documentStatus.interimpublish.value)}
                      >
                        <div className="title">{"Ban hành tạm thời"}</div>
                        {getHisNotes(documentStatus.interimpublish)}
                        <div className="des">
                          {docStatusId === 5 && !document?.IsCustomEditor && (
                            <div className="his-note-content">
                              <WordTemplateItems2 document={document} />
                            </div>
                          )}
                        </div>
                        {!isReadOnly &&
                          docStatusId === documentStatus.interimpublish.id &&
                          isView &&
                          // isOwner() &&
                          document.IsCustomEditor && (
                            <>
                              <div className="mt-3 d-flex column">
                                <Button
                                  className="mr-2"
                                  size={"sm"}
                                  onClick={() => toggleEditDocumentProcessModal()}
                                  variant="outline-info"
                                >
                                  {"Chọn người phê duyệt"}
                                </Button>
                                {/* <Button className="ml-2" size={'sm'} onClick={onSkip} variant="outline-warning">{'Bỏ qua bước kế tiếp'}</Button> */}
                                {/* <Button className="ml-2" size={'sm'} onClick={onReject} variant="outline-danger">{'Từ chối'}</Button> */}
                              </div>
                            </>
                          )}
                        {!isReadOnly &&
                          docStatusId === documentStatus.interimpublish.id &&
                          // isOwner() &&
                          !document.IsCustomEditor && (
                            <div className="mt-3 text-right">
                              <Button className="ml-2" onClick={onPublish} variant="info">
                                {"Ban hành"}
                              </Button>
                            </div>
                          )}
                      </div>
                    </div>
                    {document.IsCustomEditor && (
                      <div className="item">
                        <div className={`step ${checkActiveStep(documentStatus.approval.id) ? "approved" : "waiting"}`}>
                          {checkActiveStep(documentStatus.approval.id) && <FontFa name="faCheck" />}
                        </div>
                        <div
                          className={isStepSelected(documentStatus.approval.value) ? "content active" : "content"}
                          role="button"
                          onClick={() => handleStepClick(documentStatus.approval.value)}
                        >
                          <div className="title">{"Chờ phê duyệt"}</div>
                          <div className="des">{getHisNotes(documentStatus.approval)}</div>
                          {!isReadOnly && docStatusId === documentStatus.approval.id && getApproved() ? (
                            <>
                              <div className="mt-3 text-right">
                                <Button
                                  className="mr-2"
                                  size={"sm"}
                                  onClick={() => toggleEditDocumentProcessModal()}
                                  variant="outline-info"
                                >
                                  {"Duyệt"}
                                </Button>
                                {/* <Button className="ml-2" size={'sm'} onClick={onSkip} variant="outline-warning">{'Bỏ qua bước kế tiếp'}</Button> */}
                                <Button
                                  className="ml-2"
                                  size={"sm"}
                                  onClick={() => onReject("Phê duyệt")}
                                  variant="outline-danger"
                                >
                                  {"Từ chối"}
                                </Button>
                              </div>
                            </>
                          ) : (
                            docStatusId === documentStatus.approval.id && (
                              // isOwner() && (
                              <div className="mt-3 text-right">
                                <Button
                                  className="mr-2"
                                  size={"sm"}
                                  onClick={() => toggleEditDocumentProcessModal(true)}
                                  variant="outline-info"
                                >
                                  {"Đổi người phê duyệt"}
                                </Button>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                    {document.IsCustomEditor && (
                      <div className="item">
                        <div
                          className={`step ${
                            checkActiveStep(documentStatus.readytopublish.id) ? "approved" : "waiting"
                          }`}
                        >
                          {checkActiveStep(documentStatus.readytopublish.id) && <FontFa name="faCheck" />}
                        </div>
                        <div
                          className={isStepSelected(documentStatus.readytopublish.value) ? "content active" : "content"}
                          role="button"
                          onClick={() => handleStepClick(documentStatus.readytopublish.value)}
                        >
                          <div className="title">{"Đã phê duyệt"}</div>
                          {getHisNotes(documentStatus.readytopublish)}
                          {document.approvedName && (
                            <div className="des">Cán bộ phê duyệt: {document.approvedName}</div>
                          )}
                          <div className="des">
                            {(docStatusId === 7 || docStatusId === 8) && (
                              <div className="his-note-content">
                                <WordTemplateItems
                                  document={document}
                                  reason={
                                    documentHis?.find((e: { docStatusValue: string }) => e.docStatusValue === "compose")
                                      ?.docNotes || ""
                                  }
                                />
                              </div>
                            )}
                          </div>
                          {!isReadOnly && docStatusId === documentStatus.readytopublish.id && (
                            //  && isOwner()
                            <>
                              <div className="mt-3 text-right">
                                <Button className="mr-2" size={"sm"} onClick={onPublish} variant="outline-info">
                                  {"Ban hành"}
                                </Button>
                                <Button
                                  className="ml-2"
                                  size={"sm"}
                                  onClick={() => onReject("phê duyệt")}
                                  variant="outline-danger"
                                >
                                  {"Từ chối"}
                                </Button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="item">
                      <div className={`step ${checkActiveStep(documentStatus.publish.id) ? "approved" : "waiting"}`}>
                        {checkActiveStep(documentStatus.publish.id) && <FontFa name="faCheck" />}
                      </div>
                      <div
                        className={isStepSelected(documentStatus.publish.value) ? "content active" : "content"}
                        role="button"
                        onClick={() => handleStepClick(documentStatus.publish.value)}
                      >
                        <div className="d-flex">
                          <div className="title">{"Ban hành"}</div>
                        </div>
                        <div className="des">
                          {getHisNotes(documentStatus.publish)}
                          {docStatusId === 8 && document?.fileAssignedTo && (
                            <div className="his-note-content">
                              <WordTemplateItems2 document={document} />
                            </div>
                          )}
                          {document.docPublicVersion > 0 && (
                            <div className="mt-5">
                              <Button variant="primary" onClick={() => setIsOpenModal(true)}>
                                Xem lịch sử ban hành
                              </Button>
                            </div>
                          )}
                        </div>
                        {!isReadOnly && (
                          <div className="mt-3 text-right">
                            {/* <Button className="mr-2" onClick={onReject} variant="danger">{'Hủy'}</Button> */}
                            {document.IsCustomEditor &&
                              docStatusId !== documentStatus.publish.id &&
                              // isOwner() &&
                              docStatusId !== documentStatus.approval.id && (
                                <Button className="ml-2" onClick={onPublish} variant="info">
                                  {"Ban hành"}
                                </Button>
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {document.IsCustomEditor && (
              <Col xs={9} sm={9} className="px-0">
                <DetailDocumentStepInfo />
                {step === "publish" &&
                  !isPublishStatus &&
                  document?.userEmail === user?.current?.username?.toLowerCase() && (
                    <Space className="d-flex justify-content-end mb-2">
                      <Button disabled={!mode} variant="secondary" onClick={() => handlePermissionContent("")}>
                        Trở về
                      </Button>
                      <Button
                        disabled={!!mode || !document?.isContentPermission}
                        onClick={() => handlePermissionContent("decentralize")}
                      >
                        Phân quyền đọc trên đoạn
                      </Button>
                    </Space>
                  )}
                <DetailDocumentViewEditor />
              </Col>
            )}
          </Row>
        </div>
      </Box>
      <LoadingModal
        isOpen={!isView}
        text={
          docStatusId === documentStatus.publish.id
            ? "Hệ thống đang tiến hành ban hành"
            : "Hệ thống đang tiến hành ban hành tạm thời"
        }
        onClose={() =>
          CreateNotification({
            title: "Thành công",
            body: "Tiến hành ban hành tạm thời thành công!",
            icon: "/icons/success.png",
          })
        }
      />
      <ContentHistoryVersionModal isOpenModal={isOpenModal} onClose={() => setIsOpenModal(false)} />
    </div>
  );
};
